import { ComponentF } from "../../../ui/ui";
import { withColor } from "../../../ui/uiText";
import { Target, TargetTypes } from "../../abilities/Target";
import Colors from "../../Colors";
import { Item } from "../../items/Item";

export const targetTypeLabel = (target: Target) => {
  switch (target.type) {
    case TargetTypes.SELF:
      return ["Self", Colors.AQUA_3];
    case TargetTypes.TARGET:
      return ["Ground", Colors.GRAY_2];
    case TargetTypes.PIECE:
      return ["Letter", Colors.GRAY_3];
    default:
      return ["", Colors.GRAY_1];
  }
};

export const ItemDetailDisplay: ComponentF<{ item: Item | null }> = (
  C,
  { item }
) => {
  if (item === null) {
    return;
  }

  let y = C.bounds.y;

  C.display.drawText(C.bounds.x, y, item.breed.name, C.bounds.w - 1);
  y += 1;
  C.display.drawText(C.bounds.x, y, `Quantity: ${item.uses}`);
  y += 1;

  C.display.drawText(
    C.bounds.x,
    y,
    withColor(Colors.LIGHT_GRAY_1, item.breed.description || "")
  );

  y = C.bounds.y;
  if (item.breed.useAbility?.target) {
    const target = item.breed.useAbility.target;
    const [label, color] = targetTypeLabel(target);
    C.display.drawText(
      C.bounds.x + C.bounds.w - label.length,
      y,
      withColor(color, label)
    );
    y += 1;
    if (target.distance) {
      const label = `${target.distance} Range`;
      C.display.drawText(C.bounds.x + C.bounds.w - label.length, y, label);
      y += 1;
    }

    if (!item.breed.useAbility.advancesTurn) {
      C.display.drawText(
        C.bounds.x + C.bounds.w - 7, //7 is length of "Instant"
        y,
        `%c{${Colors.GRAY_2}}Instant%c{}`
      );
    }
  }
};
